<template>
    <div>
        <div class="page-wrapper">
            <div class="container-fluid">
                <div class="authentication-main">
                    <div class="row">
                        <div class="col-md-12 p-0">
                            <div class="auth-innerright">
                                <div class="reset-password-box col-10">
                                    <div class="text-center">
                                        <img alt="" src="../../../assets/images/logo_gms.png" style="width: 405px">
                                    </div>
                                    <div class="card mt-4 m-b-5" id="tracking_dispatch">
                                        <div class="card">
                                            <div class="card-body" v-if="client">
                                                <h4><b>{{client.business_name}}</b> - Guía de Despacho <b>{{tracking_code}}</b></h4>
                                            </div>
                                        </div>
                                        <div v-for="dispatch in dispatchList" :key="dispatch.id" class="row equal-height-lg">
                                            <div v-for="observation in dispatch.dispatchchangestatus_set" :key="observation.id" class="col-4">
                                                <div class="pricing-block card h-90">
                                                    <div :style="{'background-color': getColor(observation.status.id)}" class="border-card-color"></div>
                                                    <div class="card-header mt-3">
                                                        <h3 :style="{'color': getColor(observation.status.id)}" class="text-center">{{observation.status.name}}</h3>
                                                    </div>
                                                    <div class="card-body">
                                                        <div class="pricing-inner">
                                                            <p v-html="observation.system_observation"></p>
                                                            <p>Observación del trabajador: {{observation.worker_observation}}</p>
                                                        </div>
                                                    </div>
                                                    <div class="card-footer">
                                                        <span>Fecha de actualización: <b>{{observation.date_register}}</b></span>
                                                        <div v-if="observation.dispatchchangestatusposition" class="form-group form-row mt-3 mb-0">
                                                            <button class="btn btn-success btn-block" type="button" v-on:click="displayModalMap(observation.dispatchchangestatusposition)"><i class="fa fa-map-marker"></i> Visualizar entrega</button>
                                                        </div>
                                                        <!--                                                        {{observation.dispatchchangestatusposition}}-->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="map" centered size="lg" title="Mapa de entrega" ok-title="Cerrar" ok-only class="theme-modal">
            <GmapMap  style="width: 100%; height: 500px" ref="mapRef"
                      :center="optionsMap.center"
                      :zoom="optionsMap.zoom"
            >
                <gmap-marker :key="i" v-for="(m,i) in markers" :position="m.position"></gmap-marker>
            </GmapMap>
        </b-modal>
    </div>
</template>
<script>
    import utils from '../../../utils';
    import axios from "axios";

    export default {
        data(){
            return {
                objectId: null,
                dispatchList: [],
                markers: [],
                tracking_code: null,
                client: null,
                optionsMap: {
                    center: {lat: -33.4488897, lng: -70.6692655},
                    zoom: 15,
                },
            }
        },
        mounted() {
            this.objectId = this.$route.params.objectId;
            this.loadData();
        },
        methods: {
            getColor(status){
                if (status === '0'){
                    return '#ff9f40';
                }// EN SINCRONIZACIÓN
                else if (status === '300'){
                    return '#6f42c1';
                }
                // PENDIENTE RUTA ASIGNADA, EM DESPACHO
                else if(['4', '280', '220'].includes(status)){
                    return '#4466f2';
                }// ENTREGADO -- VUELTA AL INVENTARIO - REASIGNADO
                else if (['1', '290', '310'].includes(status)){
                    return '#22af47';
                }// DESCONOCIDO, NO HAY QUIEN RECIBA, 1 IDA
                else if(['50', '60', '250'].includes(status)){
                    return '#6f42c1';
                }  // DIRECCIÓN INCOMPLETA - NO HAY NÚMERO - CAMBIO DE DOMICILIO - CAMBIO DOMICILIO - REHUSADA - 2 ida
                else if (utils.syncStatusDispatch.includes(status)){
                    return '#ff5370';
                }
            },
            loadData(){
                const path = `/api/inventory/v1.0/dispatch_tracking/${this.objectId}/`;
                const config = {
                    headers: {'Authorization': '' },
                };
                axios.get(path, config).then((response) => {
                    // RECORREMOS CADA DESPACHO
                    response.data.forEach((item) => {
                        this.tracking_code = item['tracking_code'];
                        this.client = item['client'];
                        // RECORREMOS CADA MENSAJE
                        this.dispatchList.push(item);
                    });
                }).catch((error) => {
                    // ERROR 401 DA CUANDO NO SE ENVÍA EL TOKEN
                    console.log(error.response);
                    if(error.response.status === 400){
                        this.$swal({
                            title: 'Error',
                            type: 'error',
                            html: `Ha habido en error al conectarse con el servidor, intente nuevamente. Si el problema continúa, póngase en contacto con el administrador del sistema.`,
                        });
                    }
                })
            },
            async displayModalMap(data) {
                const marker = {
                    lat: parseFloat(data.lat),
                    lng: parseFloat(data.lng)
                }
                this.markers = [
                    {
                        position: marker
                    }
                ]
                this.optionsMap.center = marker
                await this.$bvModal.show('map');
            },
        }
    }
</script>
<style>
    #tracking_dispatch .card .card-footer{
        padding: 5px;
    }
    #tracking_dispatch .card .card-header{
        padding: 5px;
    }
    #tracking_dispatch .card .card-body{
        padding: 10px !important;
    }
    .h-90 {
        height: 90% !important;
    }

    #tracking_dispatch .border-card-color{
        height: 20px;
        border-top-left-radius: 70px;
        border-top-right-radius: 70px;
    }
</style>